export const pressData = [
    {
        logo: "./images/Chicago Reader Logo.png",
        link: "https://chicagoreader.com/food-drink/moonwalker-cafe-is-the-scratch-kitchen-every-neighborhood-deserves/",
        altText: "chicago reader logo"
    },
    {
        logo: "./images/Chicago Magazine.png",
        link: "https://www.chicagomag.com/chicago-magazine/december-2021/the-10-hottest-restaurants-in-chicago-right-now-10/",
        altText: "chicago magazine logo"
    },
    
]